/* ============================================================================
   CYQ dataLayer bridge — Casa y Quincho
   Container: GTM-K622B9FK
   Cubre: storefront events (todo excepto checkout sandbox)
     - view_item        (product page)
     - view_item_list   (collection page)
     - select_item      (click producto en collection)
     - add_to_cart      (UNA sola fuente: el wrapper de fetch a /cart/add(.js), item_id = id de VARIANTE)
     - search           (busqueda en /search)

   9a (21-oct-2026, SEO Macro 2.0): antes cada agregado empujaba add_to_cart 2 veces (submit con variante +
   fetch con product_id; el anti-duplicado no los juntaba porque el item_id era distinto) y cyq-pdp.js
   empujaba otro más en la ficha. Ahora el fetch es la única fuente; el submit solo empuja si el form se envía
   SIN AJAX (nadie llamó preventDefault), cosa que hoy no pasa en ningún form del tema.

   begin_checkout y purchase viven en checkout sandbox y se cubren via
   Shopify Customer Events (Settings -> Customer events). Ver INSTALAR_CUSTOMER_EVENTS.md
   ========================================================================== */
(function () {
  if (window.__cyq_dl_loaded) return;
  window.__cyq_dl_loaded = true;
  window.dataLayer = window.dataLayer || [];

  function moneyToNumber(s) {
    if (s == null) return 0;
    if (typeof s === 'number') return s;
    var v = parseFloat(String(s).replace(/[^\d.,-]/g, '').replace(/\./g, '').replace(',', '.'));
    return isFinite(v) ? v : 0;
  }

  // dedup: si el mismo evento con los mismos items se pushea < 2000ms despues,
  // se ignora. Evita doble conteo cuando el theme dispara submit + fetch.
  var _lastPush = { event: null, key: '', t: 0 };
  function _itemsKey(p) {
    try {
      var items = (p && p.ecommerce && p.ecommerce.items) || [];
      return items.map(function (i) { return i.item_id + '|' + (i.quantity || 1); }).join(',');
    } catch (e) { return ''; }
  }
  function pushClean(p) {
    if (!p || !p.event) return;
    var key = _itemsKey(p);
    var now = Date.now();
    if (_lastPush.event === p.event && _lastPush.key === key && (now - _lastPush.t) < 2000) {
      return; // duplicado, ignorar
    }
    _lastPush = { event: p.event, key: key, t: now };
    try { window.dataLayer.push({ ecommerce: null }); window.dataLayer.push(p); } catch(e) {}
  }
  function getMeta(name) {
    var el = document.querySelector('meta[name="' + name + '"]');
    return el ? el.getAttribute('content') : null;
  }

  // ---- 1. view_item (product page) ----------------------------------------
  function fireViewItem() {
    if (!/\/products\//.test(location.pathname)) return;
    // intentar leer datos del JSON-LD product schema (si existe) o de window.ShopifyAnalytics
    var item = null;

    // a) JSON-LD
    try {
      var lds = document.querySelectorAll('script[type="application/ld+json"]');
      for (var i = 0; i < lds.length; i++) {
        var data = JSON.parse(lds[i].textContent);
        var arr = Array.isArray(data) ? data : [data];
        for (var j = 0; j < arr.length; j++) {
          var d = arr[j];
          if (d && (d['@type'] === 'Product' || (Array.isArray(d['@type']) && d['@type'].indexOf('Product') >= 0))) {
            var offers = d.offers || {};
            if (Array.isArray(offers)) offers = offers[0] || {};
            item = {
              item_id: d.sku || d.productID || '',
              item_name: d.name || '',
              item_brand: (d.brand && (d.brand.name || d.brand)) || '',
              item_category: d.category || '',
              price: moneyToNumber(offers.price),
              quantity: 1
            };
            break;
          }
        }
        if (item) break;
      }
    } catch (e) {}

    // b) ShopifyAnalytics fallback
    if (!item && window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
      var p = window.ShopifyAnalytics.meta.product;
      var v = (p.variants && p.variants[0]) || {};
      item = {
        item_id: v.sku || String(v.id || p.id || ''),
        item_name: v.name || p.type || '',
        item_brand: p.vendor || '',
        item_category: p.type || '',
        price: moneyToNumber((v.price || 0) / 100),
        quantity: 1
      };
    }

    if (!item) return;
    pushClean({
      event: 'view_item',
      ecommerce: { currency: getMeta('currency') || 'CLP', value: item.price, items: [item] }
    });
  }

  // ---- 2. view_item_list (collection page) --------------------------------
  function fireViewItemList() {
    if (!/\/collections\//.test(location.pathname) || /\/products\//.test(location.pathname)) return;
    var items = [];
    var meta = (window.ShopifyAnalytics && window.ShopifyAnalytics.meta) || {};
    var prods = meta.products || [];
    if (prods.length) {
      // fuente confiable: ShopifyAnalytics.meta.products
      // (mismo SKU que emite view_item -> IDs alineados ficha<->coleccion)
      for (var k = 0; k < prods.length && items.length < 24; k++) {
        var pr = prods[k];
        var vr = (pr.variants && pr.variants[0]) || {};
        items.push({
          item_id: String(vr.sku || pr.id || ''),
          item_name: vr.name || pr.type || '',
          item_brand: pr.vendor || '',
          price: moneyToNumber((vr.price || 0) / 100),
          index: items.length + 1
        });
      }
    } else {
      // fallback DOM (themes sin ShopifyAnalytics.meta.products)
      var cards = document.querySelectorAll('[data-product-id], a[href*="/products/"]');
      var seen = {};
      for (var i = 0; i < cards.length && items.length < 24; i++) {
        var c = cards[i];
        var pid = c.getAttribute('data-product-id') || (c.getAttribute('href') || '').split('/products/')[1] || '';
        pid = pid.split('?')[0].split('#')[0];
        if (!pid || seen[pid]) continue;
        seen[pid] = true;
        var nameEl = c.querySelector('[data-product-title], .product-title, .card__heading, h2, h3') || c;
        items.push({
          item_id: pid,
          item_name: (nameEl.textContent || '').trim().slice(0, 120),
          index: items.length + 1
        });
      }
    }
    if (!items.length) return;
    var listName = (document.querySelector('h1') || {}).textContent || location.pathname;
    pushClean({
      event: 'view_item_list',
      ecommerce: { item_list_id: location.pathname, item_list_name: listName.trim(), items: items }
    });
  }

  // ---- 3. select_item (click sobre product card) --------------------------
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="/products/"]');
    if (!a) return;
    if (/\/cart/.test(a.href)) return;
    var pid = (a.getAttribute('href') || '').split('/products/')[1];
    if (!pid) return;
    pid = pid.split('?')[0].split('#')[0];
    var nameEl = a.querySelector('[data-product-title], .product-title, .card__heading, h2, h3');
    var name = (nameEl ? nameEl.textContent : a.textContent || '').trim().slice(0, 120);
    pushClean({
      event: 'select_item',
      ecommerce: { items: [{ item_id: pid, item_name: name }] }
    });
  }, true);

  // ---- 4. add_to_cart -------------------------------------------------------
  // 4a. Respaldo para forms /cart/add que se envían SIN AJAX (recarga a /cart). Escucha en window, fase de
  //     burbuja, o sea DESPUÉS de los handlers del tema: si alguno hizo preventDefault, el agregado va por
  //     fetch y lo cuenta 4b; aquí no se empuja nada (antes se empujaba siempre y se contaba doble).
  window.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || f.tagName !== 'FORM') return;
    if (e.defaultPrevented) return;
    var action = (f.getAttribute('action') || '').toLowerCase();
    if (action.indexOf('/cart/add') < 0) return;

    var fd = new FormData(f);
    var qty = parseInt(fd.get('quantity') || '1', 10) || 1;
    var vid = fd.get('id') || '';
    var name = '';
    var price = 0;
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
      var p = window.ShopifyAnalytics.meta.product;
      name = p.type || '';
      var match = (p.variants || []).filter(function (v) { return String(v.id) === String(vid); })[0];
      if (match) { price = moneyToNumber(match.price / 100); name = match.name || name; }
    }
    pushClean({
      event: 'add_to_cart',
      ecommerce: {
        currency: getMeta('currency') || 'CLP',
        value: price * qty,
        items: [{ item_id: String(vid), item_name: name, price: price, quantity: qty }]
      }
    });
  }, false);

  // 4b. Fuente principal: fetch a /cart/add.js (AJAX del tema, cyq-pdp.js, quick add, barra fija, recomendados)
  var _fetch = window.fetch;
  if (_fetch) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var isAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);
      var p = _fetch.apply(this, arguments);
      if (isAdd) {
        p.then(function (resp) {
          try {
            var clone = resp.clone();
            clone.json().then(function (data) {
              var items = data.items || (data.id ? [data] : []);
              if (!items.length) return;
              var dlItems = items.map(function (it) {
                return {
                  item_id: String(it.variant_id || it.id || ''),  // 9a: id de variante (antes product_id)
                  item_name: it.product_title || it.title || '',
                  item_variant: it.variant_title || '',
                  price: moneyToNumber((it.price || 0) / 100),
                  quantity: it.quantity || 1
                };
              });
              var value = dlItems.reduce(function (s, x) { return s + x.price * x.quantity; }, 0);
              pushClean({
                event: 'add_to_cart',
                ecommerce: { currency: getMeta('currency') || 'CLP', value: value, items: dlItems }
              });
            });
          } catch (e) {}
        });
      }
      return p;
    };
  }

  // ---- 5. search (pagina de resultados /search) ---------------------------
  function fireSearch() {
    if (!/\/search/.test(location.pathname)) return;
    var term = '';
    try { term = new URLSearchParams(location.search).get('q') || ''; } catch (e) {}
    if (!term) return;
    pushClean({ event: 'search', search_term: term });
  }

  // ---- init: dispara view_item / view_item_list / search al cargar ---------
  function cyqInit() {
    try { fireViewItem(); fireViewItemList(); fireSearch(); } catch (e) {}
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cyqInit);
  } else {
    cyqInit();
  }
})();